const PREFIX = "altiv_draft_";
const MAX_AGE_MS = 15 * 60 * 1000; // 15 min — drafts only survive short interruptions (F5, crash, deploy)

function key(formKey) {
  return `${PREFIX}${formKey}`;
}

export function saveDraft(formKey, data, route) {
  try {
    const payload = JSON.stringify({
      data,
      route: route || (typeof window !== "undefined" ? window.location.pathname : null),
      savedAt: Date.now(),
    });
    localStorage.setItem(key(formKey), payload);
  } catch {}
}

export function loadDraft(formKey) {
  try {
    const raw = localStorage.getItem(key(formKey));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    if (parsed.savedAt && Date.now() - parsed.savedAt > MAX_AGE_MS) {
      localStorage.removeItem(key(formKey));
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearDraft(formKey) {
  try {
    localStorage.removeItem(key(formKey));
  } catch {}
}

export function listDraftKeys() {
  try {
    const out = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(PREFIX)) out.push(k.slice(PREFIX.length));
    }
    return out;
  } catch {
    return [];
  }
}

export function pruneOldDrafts() {
  for (const k of listDraftKeys()) loadDraft(k);
}
